export default function Terminos() {
  return (
    <div className="min-h-screen bg-[#0d0520] text-white px-5 py-8 max-w-2xl mx-auto">
      <div className="flex items-center gap-3 mb-6">
        <button onClick={() => window.history.back()} className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center">
          <i className="ri-arrow-left-s-line text-xl" />
        </button>
        <h1 className="text-lg font-bold">Términos y Condiciones</h1>
      </div>

      <div className="bg-white/5 rounded-2xl p-5 space-y-5 text-sm leading-relaxed text-gray-200">

        <div>
          <p className="text-xs text-gray-400 mb-1">COVERLY S.A.S. DE C.V. · Culiacán, Sinaloa, México</p>
          <p className="text-xs text-gray-400">Versión 1.0 · Vigente a partir de 2025</p>
        </div>

        <section>
          <h2 className="text-white font-bold text-base mb-2">TÉRMINOS Y CONDICIONES DE USO</h2>
          <p>
            Al acceder y utilizar la plataforma digital de <strong className="text-white">COVERLY</strong> (app web, WhatsApp y cualquier canal digital),
            usted acepta íntegramente los presentes Términos y Condiciones. Si no está de acuerdo, le pedimos
            no utilizar nuestros servicios.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">1. USO DE LA PLATAFORMA</h2>
          <p className="mb-2">Al usar Coverly, usted declara:</p>
          <ul className="space-y-1 pl-3 list-disc list-inside">
            <li>Ser mayor de 18 años o contar con autorización de un tutor legal.</li>
            <li>Proporcionar información verídica y actualizada en su registro.</li>
            <li>Usar la plataforma exclusivamente para contratar y gestionar su membresía.</li>
            <li>No realizar actividades fraudulentas, ilegales o que perjudiquen a terceros.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">2. CUENTA Y SEGURIDAD</h2>
          <p>
            Usted es responsable de mantener la confidencialidad de su número de teléfono y datos de acceso.
            Cualquier actividad realizada desde su cuenta es su responsabilidad. Notifique inmediatamente a
            COVERLY si detecta uso no autorizado de su cuenta al WhatsApp 667-568-0042.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">3. PAGOS Y FACTURACIÓN</h2>
          <ul className="space-y-2 pl-3">
            <li>Los pagos se procesan mensualmente de forma recurrente.</li>
            <li>Aceptamos tarjetas de débito/crédito (Visa, Mastercard, AMEX) y pagos en efectivo en tiendas de conveniencia (OXXO, 7-Eleven).</li>
            <li>Los pagos son procesados por <strong className="text-white">Conekta</strong>, plataforma certificada PCI-DSS. COVERLY no almacena datos de tarjetas.</li>
            <li>En caso de pago rechazado, la membresía se suspende hasta regularizar el pago.</li>
            <li>Los precios están expresados en Pesos Mexicanos (MXN) e incluyen IVA cuando aplica.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">4. POLÍTICA DE REEMBOLSOS</h2>
          <p>
            COVERLY no realiza reembolsos de mensualidades ya pagadas. Si cancela su membresía antes del
            vencimiento del periodo mensual, conservará la cobertura hasta el último día del periodo pagado.
            En caso de error de cobro duplicado, COVERLY realizará el reembolso correspondiente en un
            plazo de 5 a 10 días hábiles.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">5. PROPIEDAD INTELECTUAL</h2>
          <p>
            Todos los elementos de la plataforma Coverly (logotipo, diseño, textos, código, marca) son
            propiedad exclusiva de COVERLY S.A.S. DE C.V. y están protegidos por las leyes de propiedad
            intelectual mexicanas e internacionales. Queda prohibida su reproducción sin autorización expresa.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">6. PRIVACIDAD Y DATOS PERSONALES</h2>
          <p className="mb-2">COVERLY recopila los siguientes datos para prestar el servicio:</p>
          <ul className="space-y-1 pl-3 list-disc list-inside">
            <li>Nombre completo, teléfono y CURP del titular y beneficiarios.</li>
            <li>Dirección de Culiacán para coordinación de servicios.</li>
            <li>Datos de pago (procesados de forma segura por Conekta).</li>
          </ul>
          <p className="mt-2">
            Sus datos se tratan conforme a la <strong className="text-white">Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)</strong>.
            Puede ejercer sus derechos ARCO (Acceso, Rectificación, Cancelación y Oposición) escribiendo a
            contacto@coverly.com.mx o al WhatsApp 667-568-0042.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">7. DISPONIBILIDAD DEL SERVICIO</h2>
          <p>
            COVERLY se esfuerza por mantener el servicio disponible 24/7. Sin embargo, pueden presentarse
            interrupciones por mantenimiento, causas de fuerza mayor o situaciones fuera de nuestro control.
            En dichos casos, COVERLY notificará a los miembros con la mayor antelación posible.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">8. CONDUCTA PROHIBIDA</h2>
          <p className="mb-2">Está estrictamente prohibido:</p>
          <ul className="space-y-1 pl-3 list-disc list-inside">
            <li>Registrar beneficiarios falsos o personas no relacionadas con el titular.</li>
            <li>Usar la membresía para actividades distintas a la previsión funeraria.</li>
            <li>Intentar acceder a sistemas o datos de otros miembros.</li>
            <li>Difamar o dañar la reputación de COVERLY mediante información falsa.</li>
          </ul>
          <p className="mt-2">
            El incumplimiento de estas prohibiciones faculta a COVERLY a cancelar la membresía
            sin reembolso y ejercer las acciones legales correspondientes.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">9. MODIFICACIONES</h2>
          <p>
            COVERLY puede modificar estos Términos y Condiciones en cualquier momento. Los cambios
            se notificarán con 30 días de anticipación. El uso continuo del servicio implica la
            aceptación de los nuevos términos.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">10. LEY APLICABLE Y JURISDICCIÓN</h2>
          <p>
            Los presentes Términos se rigen por las leyes del <strong className="text-white">Estado de Sinaloa, México</strong>.
            Cualquier controversia se resolverá ante los tribunales competentes de Culiacán, Sinaloa,
            o ante la <strong className="text-white">PROFECO</strong> (Procuraduría Federal del Consumidor) en caso de disputas de consumo.
          </p>
        </section>

        <section>
          <h2 className="text-white font-semibold mb-2">11. CONTACTO</h2>
          <ul className="space-y-1 pl-3">
            <li>📱 WhatsApp: <strong className="text-white">667-568-0042</strong></li>
            <li>🌐 Web: <strong className="text-white">coverly.com.mx</strong></li>
            <li>📧 Email: <strong className="text-white">contacto@coverly.com.mx</strong></li>
            <li>📍 Culiacán, Sinaloa, México</li>
          </ul>
        </section>

        <div className="border-t border-white/10 pt-4 text-xs text-gray-400">
          <p>
            Al crear una cuenta y utilizar los servicios de Coverly, usted confirma haber leído,
            comprendido y aceptado la totalidad de estos Términos y Condiciones, así como nuestro
            Contrato de Membresía y Aviso de Privacidad, en conformidad con la legislación mexicana vigente.
          </p>
          <p className="mt-2">COVERLY S.A.S. DE C.V. · Culiacán, Sinaloa · 667-568-0042</p>
        </div>

      </div>
    </div>
  );
}
